import { render, staticRenderFns } from "./ShortcutKey.vue?vue&type=template&id=7ed591ba&scoped=true&"
import script from "./ShortcutKey.vue?vue&type=script&lang=js&"
export * from "./ShortcutKey.vue?vue&type=script&lang=js&"
import style0 from "./ShortcutKey.vue?vue&type=style&index=0&id=7ed591ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed591ba",
  null
  
)

export default component.exports